import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './../../assets/scss/close-project.scss'
import closeIcon from './../../assets/icons/close.svg'
function CloseProject() {
    return (
        <div className="close-project-wrapper">
            <Link to='/'  >
                <img src={closeIcon} className="close-project" alt="Close button" />
            </Link>
        </div>
    );
}

export default CloseProject;